/**
 * Corner control that hides a tile. Does not delete the KPI or composite.
 */

import React from 'react';

interface TileHideButtonProps {
  label: string;
  onHide: () => void;
}

export const TileHideButton: React.FC<TileHideButtonProps> = ({ label, onHide }) => (
  <button
    type="button"
    className="absolute top-0.5 right-0.5 z-10 w-4 h-4 leading-none text-[11px] text-[var(--color-secondary-text)] hover:text-[var(--color-surface-text)]"
    aria-label={label}
    title={label}
    onClick={(event) => {
      event.preventDefault();
      event.stopPropagation();
      onHide();
    }}
  >
    ×
  </button>
);
